import Card from '@/models/Card'

export default class CardRepo {
	static endpoint = '/api/card'

	static fetchAll () {
		return Card.api().get(this.endpoint)
	}
}
